import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import { LEGAL_DISCLAIMER_PARAGRAPHS } from './legalDisclaimerText';
import { legalDisclaimerPanelStyles as styles } from './LegalDisclaimerPanel.styles';

interface LegalDisclaimerPanelProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Full legal disclaimer text, opened from the footer bar's "Read more".
 * Slides in from the right; closes on the ✕, the backdrop, or Escape.
 */
export function LegalDisclaimerPanel({ open, onClose }: LegalDisclaimerPanelProps) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} slotProps={{ paper: { sx: styles.paper } }}>
      <Box sx={styles.header}>
        <Typography component="h2" sx={styles.title}>
          Legal Disclaimer
        </Typography>
        <IconButton aria-label="Close" onClick={onClose} sx={styles.close}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={styles.body}>
        {LEGAL_DISCLAIMER_PARAGRAPHS.map((paragraph, index) =>
          index === 0 ? (
            <Typography key={index} sx={styles.paragraph}>
              Worker Solutions LLC (&ldquo;Worker Solutions&rdquo;) aims to
              keep the information on this website accurate and up to date.
              This information may be different than what you see when you
              visit the government, a financial institution, service
              provider or other website. All services and information
              provided by Worker Solutions or presented on this website are
              provided and presented without warranty. When evaluating
              results from the Opportunity Map, please review Worker
              Solutions&rsquo;{' '}
              <Link href="/privacy-policy" sx={styles.link}>
                Privacy Policy
              </Link>
              , as well as its{' '}
              <Link href="/terms-and-conditions" sx={styles.link}>
                Terms and Conditions
              </Link>
              .
            </Typography>
          ) : (
            <Typography key={index} sx={styles.paragraph}>
              {paragraph}
            </Typography>
          ),
        )}
      </Box>
    </Drawer>
  );
}
